import { Button, Col, Grid, Row } from '@rocketmakers/armstrong';
import * as React from 'react';
import { DeviceType, HeatFlowMeterSharky } from '../../../../shared/api-clients/_api';
import { useRoutePaths } from '../../../../shared/context/paths';
import { BackButton } from '../../components/buttons/back-button';
import { DeviceSummary } from '../../components/layout/deviceSummary/device-summary';
import { Spinner } from '../../components/spinner/spinner';
import { useBeeConfig } from '../../hooks/beeConfig';
import { routePaths } from '../../routes';
import './add-meters.scss';

export const AddMetersHeatFlowView: React.FunctionComponent = () => {
  const { push } = useRoutePaths();
  const { getDevicesByType, pushDevicesToConfig, devices, loading } = useBeeConfig();
  const handleAddMeter = () => {
    push(routePaths.heatAndFlowMeters.configure);
  };

  const heatFlowMeters = React.useMemo(() => getDevicesByType<HeatFlowMeterSharky>([DeviceType.SHARKY]), [devices]);

  const handleNext = async () => {
    await pushDevicesToConfig();
    push(routePaths.thermostat.addDial);
  };

  return (
    <div className="meter-type">
      {loading && <Spinner />}
      <BackButton />
      <h1>
        Configuration <span className="color-primary">Heat and flow meters</span>
      </h1>
      <Grid className="grid">
        <Row>
          {heatFlowMeters?.map(device => (
            <DeviceSummary
              key={device.params.install_location}
              onSelect={() => {
                push(routePaths.heatAndFlowMeters.edit, {
                  heatFlowMeterCircuit: device.params.heat_flow_meter_circuit,
                });
              }}
              fields={[
                { name: 'Circuit:', value: device.params.heat_flow_meter_circuit },
                { name: 'Location:', value: device.params.install_location },
              ]}
              data-qa={`device-summary-${device.params.install_location}`}
              name={`${device.deviceType} - ${device.params.install_location}`}
            />
          ))}
        </Row>
      </Grid>
      <Row className="btn-row">
        <Col>
          <Button
            className="btn-full"
            onClick={handleAddMeter}
            disabled={heatFlowMeters?.length >= 2}
            data-qa="add-button-heat-flow-meter"
          >
            Add a meter
          </Button>
        </Col>
      </Row>
      <Row className="btn-row">
        <Button className="btn-full" onClick={handleNext} data-qa="continue-button">
          Next
        </Button>
      </Row>
    </div>
  );
};
